module.exports = __webpack_public_path__ + "static/media/acai_berry_regular_plan.62027a6b.jpg";